export default {env: 'production', desc: '构建时间: 2023-11-01 00:50:12 版本: 6f9da45 时间: 2023-10-26 15:39:21 +0800 作者:zm 注释:fix', app_name: 'wechat2'}
